import { ResponseError } from '@/apis/generated/common/runtime';
import { instanceOfCsvPatchAssertErrorResponse } from '@/apis/generated/dialbunny';
import logger from '@/logger';

const log = logger.getChild('csv-handle-patch-error');

export const handlePatchErrorFactory =
  (patchErrors: Record<string, string>) =>
  async (catchError: unknown): Promise<void> => {
    if (!(catchError instanceof ResponseError)) {
      // show toast banner
      log.error('Unexpected error type:', catchError);
      return;
    }

    const json = await catchError.response.json();

    if (!instanceOfCsvPatchAssertErrorResponse(json)) {
      // show toast banner
      log.error('Unexpected error type in response:', json);
      return;
    }

    //   const patchErrors = $ta('CSV_IMPORT_PATCH_ERROR');
    if (!patchErrors[json.type]) {
      // report to o11y
      log.error('Unknown error type:', json.type);
      // show toast banner
      return;
    }

    // show toast banner
    log.log('Error handled:', patchErrors[json.type]);
  };
